import { Flex } from "antd";

import { StyledTab, StyledTabCount, StyledTabs } from "./Styled";

export interface TabItem<T extends string> {
    label: string;
    value: T;
    count?: number;
    disabled?: boolean;
}

interface UniversalTabsProps<T extends string> {
    tabs: TabItem<T>[];
    value: T;
    maxWidth?: string;
    onChange: (value: T) => void;
}

export const UniversalTabs = <T extends string>({
    tabs,
    value,
    maxWidth,
    onChange,
}: UniversalTabsProps<T>) => {
    return (
        <Flex justify="center">
            <StyledTabs
                $maxWidth={maxWidth}
                value={value}
                onChange={(v) => onChange(v as T)}
                options={tabs.map((tab) => ({
                    label: (
                        <StyledTab>
                            {tab.label}
                            {tab.count !== undefined && (
                                <StyledTabCount>{tab.count}</StyledTabCount>
                            )}
                        </StyledTab>
                    ),
                    value: tab.value,
                    disabled: tab.disabled,
                }))}
            />
        </Flex>
    );
};
